import { IntegrationType } from 'src/constants';
import { IAggregator } from 'src/types/aggregator.types';
import { getPricingChannels, IPricingChannel } from './getPricingChannels';

/**
 * The brand's point-of-sale extension instances, one entry per instance.
 *
 * Point of Sale Management is one of the downstream integration types, so
 * `getPricingChannels` has already done the per-instance expansion — this only narrows it.
 */
export const getPosInstances = (externalSystems: IAggregator[] | undefined): IPricingChannel[] =>
  getPricingChannels(externalSystems).filter(
    (channel) => channel.integrationType === IntegrationType.POINT_OF_SALE_MANAGEMENT,
  );
